import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { ChevronDownIcon, ChevronUpIcon } from '@fiverr-private/visuals';
import { appTranslate } from '../../i18n';

export interface FilterOption {
    value: string;
    label: string;
}

export interface FilterDropdownProps {
    label: string;
    value: string | null;
    options: FilterOption[];
    isOpen: boolean;
    onToggle: () => void;
    onChange: (value: string | null) => void;
}

export const FilterDropdown = ({ label, value, options, isOpen, onToggle, onChange }: FilterDropdownProps) => (
    <Container position="relative" width={{ default: '100%', md: 'auto' }}>
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="spaceBetween"
            gap="4"
            width={{ default: '100%', md: '188px' }}
            paddingX={{ default: '5', lg: '4' }}
            paddingY={{ default: '3', lg: '2' }}
            backgroundColor="white"
            cursor="pointer"
            borderWidth="sm"
            borderStyle="solid"
            borderColor="black"
            onClick={onToggle}
            borderRadius="circle"
        >
            <Typography
                as="span"
                color="black"
                size={{ default: 'b_md', lg: 'b_lg' }}
                fontWeight="semibold"
                letterSpacing="-0.18px"
                whiteSpace="nowrap"
            >
                {options.find((o) => o.value === value)?.label ?? label}
            </Typography>
            {isOpen ? <ChevronUpIcon size="sm" /> : <ChevronDownIcon size="sm" />}
        </Stack>

        {isOpen && (
            // TODO(debt): options have no keyboard navigation or role="listbox" — mouse-only.
            // Upgrade trigger: accessibility audit or WCAG requirement.
            <Stack
                direction="column"
                position="absolute"
                zIndex="popover"
                width="100%"
                top="calc(100% + 8px)"
                left={0}
                minWidth="188px"
                background="white"
                overflow="hidden"
                borderRadius="2xl"
                borderWidth="sm"
                borderStyle="solid"
                borderColor="black"
            >
                {[null, ...options].map((opt) => (
                    <Stack
                        key={opt ? opt.value : '__all__'}
                        onClick={() => onChange(opt ? opt.value : null)}
                        paddingX="4"
                        paddingY="3"
                        background="none"
                        cursor="pointer"
                        borderWidth={0}
                        textAlign="start"
                    >
                        <Typography as="span" color="black" size="b_md">
                            {opt ? opt.label : appTranslate('open_positions.filter_all')}
                        </Typography>
                    </Stack>
                ))}
            </Stack>
        )}
    </Container>
);
